export default __webpack_public_path__ + "static/media/nl-ilustracao.37a25b18.webp";